<template>
  <div class="riskDashboard">
    <h2>Risk Database</h2>
    <!-- 页面内容待开发 -->
  </div>
</template>

<script>
export default {
  name: 'RiskDashboard',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.riskDashboard {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/riskmanagement/riskDashboard.vue